export function inputTrimmer() {
    document.addEventListener(
        'focusout',
        (event) => {
            const INPUTS_TO_TRIM = [
                'input[type="email"]',
                'input.validate-email'
            ]
            if (event.target.matches(INPUTS_TO_TRIM.join(', '))) {
                /**
                 * We need to reset input to empty value because of input[type="email"] native behaviour:
                 * https://html.spec.whatwg.org/multipage/input.html#email-state-(type=email)
                 */
                const val = event.target.value.trim()
                event.target.value = ''
                event.target.value = val
            }
        },
        true
    )
}
